import {AssetMap} from "types";

export const assets2D: AssetMap[] = [
    {
        targetIndex: 0,
        glbModelSrc: '/models2D/asset_cow_debug.png'
    },
    {
        targetIndex: 1,
        glbModelSrc: '/models2D/asset_cow_debug.png'
    },
    {
        targetIndex: 2,
        glbModelSrc: '/models2D/asset_cow_debug.png'
    },
    {
        targetIndex: 3,
        glbModelSrc: '/models2D/asset_cow_debug.png'
    },
    {
        targetIndex: 4,
        glbModelSrc: '/models2D/asset_atom.png'
    },
    {
        targetIndex: 5,
        glbModelSrc: '/models2D/asset_atom.png'
    },
    {
        targetIndex: 6,
        glbModelSrc: '/models2D/asset_atom.png'
    },
    {
        targetIndex: 7,
        glbModelSrc: '/models2D/asset_atom.png'
    },
    {
        targetIndex: 8,
        glbModelSrc: '/models2D/asset_food.png'
    },
    {
        targetIndex: 9,
        glbModelSrc: '/models2D/asset_food.png'
    },
    {
        targetIndex: 10,
        glbModelSrc: '/models2D/asset_food.png'
    },
    {
        targetIndex: 11,
        glbModelSrc: '/models2D/asset_food.png'
    },
    {
        targetIndex: 12,
        glbModelSrc: '/models2D/asset_herb.png'
    },
    {
        targetIndex: 13,
        glbModelSrc: '/models2D/asset_herb.png'
    },
    {
        targetIndex: 14,
        glbModelSrc: '/models2D/asset_herb.png'
    },
    {
        targetIndex: 15,
        glbModelSrc: '/models2D/asset_herb.png'
    },
];
